import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

export default function Privacy() {
  return (
    <div className="min-h-screen relative pt-20">
      <div className="container mx-auto px-4 py-8 relative z-10 max-w-4xl">
        <Card className="glass-default border-white/10">
          <CardHeader>
            <CardTitle className="text-4xl font-bold gradient-text">Privacy Policy</CardTitle>
            <p className="text-white/60">Last updated: {new Date().toLocaleDateString()}</p>
          </CardHeader>
          <CardContent className="prose prose-invert max-w-none space-y-6">
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">1. Information We Collect</h2>
              <p className="text-white/80 leading-relaxed mb-4">
                RazientSounds collects information to provide and improve our services:
              </p>
              <ul className="list-disc list-inside text-white/80 space-y-2">
                <li><strong>Account Information:</strong> Name, email, profile picture (from Google OAuth)</li>
                <li><strong>Profile Data:</strong> Phone number, bio, artist information</li>
                <li><strong>Booking Information:</strong> Event details, dates, locations</li>
                <li><strong>Booking Details:</strong> Event information you share in booking inquiries and chats</li>
                <li><strong>Messages:</strong> Communications between users and artists</li>
                <li><strong>Usage Data:</strong> How you interact with our platform</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">2. How We Use Your Information</h2>
              <p className="text-white/80 leading-relaxed mb-4">We use your information to:</p>
              <ul className="list-disc list-inside text-white/80 space-y-2">
                <li>Facilitate bookings between users and artists</li>
                <li>Coordinate booking inquiries between you, artists and our team</li>
                <li>Send booking confirmations and notifications</li>
                <li>Improve our platform and services</li>
                <li>Prevent fraud and ensure platform security</li>
                <li>Comply with legal obligations</li>
                <li>Communicate updates and promotional offers (with consent)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">3. Information Sharing</h2>
              <p className="text-white/80 leading-relaxed mb-4">
                We share your information only in these circumstances:
              </p>
              <ul className="list-disc list-inside text-white/80 space-y-2">
                <li><strong>With Artists/Users:</strong> Booking details shared to facilitate events</li>
                <li><strong>Service Providers:</strong> Hosting, analytics and email providers that help us run the platform</li>
                <li><strong>Service Providers:</strong> Cloud hosting, email services</li>
                <li><strong>Legal Requirements:</strong> When required by law or to protect rights</li>
                <li><strong>Business Transfers:</strong> In case of merger or acquisition</li>
              </ul>
              <p className="text-white/80 leading-relaxed mt-4">
                We do not sell your personal information to third parties.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">4. Data Security</h2>
              <p className="text-white/80 leading-relaxed">
                We implement industry-standard security measures including encryption, secure servers, and regular security audits. However, no method of transmission over the Internet is 100% secure.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">5. Your Rights</h2>
              <p className="text-white/80 leading-relaxed mb-4">You have the right to:</p>
              <ul className="list-disc list-inside text-white/80 space-y-2">
                <li>Access your personal information</li>
                <li>Correct inaccurate data</li>
                <li>Request deletion of your account and data</li>
                <li>Object to certain data processing</li>
                <li>Export your data</li>
                <li>Withdraw consent for marketing communications</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">6. Cookies and Tracking</h2>
              <p className="text-white/80 leading-relaxed">
                We use cookies and similar technologies to maintain your session, remember preferences, and analyze platform usage. You can control cookies through your browser settings.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">7. Data Retention</h2>
              <p className="text-white/80 leading-relaxed">
                We retain your information as long as your account is active or as needed to provide services. After account deletion, we may retain certain information for legal and business purposes.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">8. Children&apos;s Privacy</h2>
              <p className="text-white/80 leading-relaxed">
                RazientSounds is not intended for users under 18. We do not knowingly collect information from children.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">9. International Users</h2>
              <p className="text-white/80 leading-relaxed">
                Your information may be transferred and processed in countries other than your own. By using RazientSounds, you consent to such transfers.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">10. Changes to Privacy Policy</h2>
              <p className="text-white/80 leading-relaxed">
                We may update this policy periodically. Continued use after changes constitutes acceptance of the updated policy.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">11. Contact Us</h2>
              <p className="text-white/80 leading-relaxed">
                For privacy concerns or data requests, contact us at privacy@razientsounds.com
              </p>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
